import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { injectIntl, FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router';
import Helmet from 'react-helmet';

import BoxButton from '../partials/BoxButton';
import Text from '../partials/Text';
import Map from '../partials/Map';
import Blocks from '../blocks/Blocks';

import mapStyles from '../../data/map.json';
import styles from '../../../styles/pages/contact.scss';

const propTypes = {
    intl: PropTypes.shape({
        formatMessage: PropTypes.func,
    }).isRequired,
    latitude: PropTypes.number.isRequired,
    longitude: PropTypes.number.isRequired,
    googleApiKey: PropTypes.string.isRequired,
    page: PropTypes.shape({
        data: PropTypes.shape({
            blocks: PropTypes.array,
        }),
    }).isRequired,
};

const Contact = ({
    intl, page, latitude, longitude, googleApiKey,
}) => (
    <div className={styles.container}>
        <Helmet>
            <title>
                {intl.formatMessage(
                    {
                        id: 'meta.title_page',
                        defaultMessage: 'Accueil',
                    },
                    {
                        title: get(page, 'title', ''),
                    },
                )}
            </title>
        </Helmet>
        <div
            className={classNames({
                [styles.section]: true,
                [styles.header]: true,
            })}
        >
            <div className={styles.cols}>
                <div
                    className={classNames({
                        [styles.col]: true,
                        [styles.colTitle]: true,
                    })}
                >
                    <h1 className={styles.title}>{get(page, `data.title.${intl.locale}`, null)}</h1>
                </div>
            </div>
        </div>
        <div
            className={classNames({
                [styles.section]: true,
                [styles.content]: true,
            })}
        >
            <div className={styles.inner}>
                <h4>Catbird Productions inc.</h4>
                <div className={styles.cols}>
                    <div
                        className={classNames({
                            [styles.col]: true,
                            [styles.colAddress]: true,
                        })}
                    >
                        <dl className={styles.list}>
                            <dt>
                                <FormattedMessage id="content.email_label" defaultMessage="Email" />
                            </dt>
                            <dd>info@catbirdproductions.ca</dd>
                            <dt>
                                <FormattedMessage id="content.phone_label" defaultMessage="Phone" />
                            </dt>
                            <dd>
                                <FormattedMessage
                                    id="content.phone"
                                    defaultMessage="+1.514.419.8590"
                                />
                            </dd>
                            <dt className={styles.large}>
                                <FormattedMessage
                                    id="content.address_label"
                                    defaultMessage="Address"
                                />
                            </dt>
                            <dd className={styles.large}>
                                <Text>
                                    {intl.formatMessage({
                                        id: 'content.address',
                                        defaultMessage:
                                            '210b ave Mozart west<br/>Montreal, QC<br/>H2S 1C4<br/>CANADA',
                                    })}
                                </Text>
                            </dd>
                        </dl>
                    </div>
                    <div
                        className={classNames({
                            [styles.col]: true,
                            [styles.colDescription]: true,
                        })}
                    >
                        <div className={styles.blocks}>
                            <Blocks items={get(page, 'data.blocks', [])} />
                        </div>
                        <div className={styles.link}>
                            <BoxButton
                                label={{
                                    id: 'content.contact_us',
                                    defaultMessage: 'Contact us',
                                }}
                                red
                                external
                                externalTarget="_self"
                                link="mailto:info@catbirdproductions.ca"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div
            className={classNames({
                [styles.section]: true,
                [styles.mapSection]: true,
            })}
        >
            <div className={styles.inner}>
                <Map
                    latitude={latitude}
                    longitude={longitude}
                    zoom={15}
                    apiKey={googleApiKey}
                    markers={[
                        {
                            latitude,
                            longitude,
                            icon: {
                                url: '/img/icon-marker.png',
                                scaledSize: {
                                    width: 32,
                                    height: 48,
                                },
                            },
                        },
                    ]}
                    styles={mapStyles}
                    className={styles.map}
                />
            </div>
        </div>
    </div>
);

Contact.propTypes = propTypes;

const mapStateToProps = ({ site, layout }, { location }) => ({
    ...layout.size,
    ...site.position,
    googleApiKey: site.googleApiKey,
    page:
        site.page !== null && site.page.url === location.pathname
            ? site.page
            : site.pages.find(it => it.url === location.pathname) || null,
});
const WithStateContainer = connect(mapStateToProps)(Contact);
const WithIntlContainer = injectIntl(WithStateContainer);
const WithRouterContainer = withRouter(WithIntlContainer);

export default WithRouterContainer;



// WEBPACK FOOTER //
// ./js/components/pages/Contact.jsx